import { ANTD_LOCALES, DAYJS_LOCALES } from '../../resources/lang/languages.generated';

// antd's own strings (date picker month and day names, pagination, empty states,
// Popconfirm buttons) and the dayjs locale its date components format with, per shipped
// language, from the generated registry. English is en-GB for the Monday-first week the
// European merchants expect.

/** The antd and dayjs locales for an i18next language, English for anything unshipped. */
export function antdLocaleFor(language) {
  const base = String(language ?? '')
    .split(/[-_]/)[0]
    .toLowerCase();

  return {
    antd: ANTD_LOCALES[base] ?? ANTD_LOCALES.en,
    dayjs: DAYJS_LOCALES[base] ?? DAYJS_LOCALES.en,
  };
}

export const ANTD_LOCALE_LANGUAGES = Object.keys(ANTD_LOCALES);
